import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteComparePlansFragment = contentfulGql`#graphql
  fragment EntWebsiteComparePlans on EntWebsiteComparePlans {
    slug
    name
    description
    subDescription
    productsCollection(limit: 10) {
      items {
        slug
        name
        description
        unitPrice
        priceDescription
        ctaText
        ctaTarget
        ctaVariant
        numUsers
        backgroundColor
      }
    }
    featureGroupsCollection(limit: 10) {
      items {
        slug
        name
        featuresCollection(limit:10) {
          items {
            slug
            name
          }
        }
      }
    }
    matrix
    useRedesign
  }
`;

export const entWebsiteBlockComparePlansQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteComparePlansFragment}
  query entWebsiteBlockComparePlans($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteComparePlans
      }
    }
  }
`;
